<template>
    <div class="rentals-list-w">

        <SessionRail :sessions="sessions" :selectedSession="selectedSession" @sessionRailInterface="onChangeSession" />

        <div class="rentals-list">
            <div class="list-controls">
                <div class="list-info export">
                    <div class="btn-group mr-1 mb-1 mt-1">
                        <button aria-expanded="false" aria-haspopup="true" class="btn btn-white dropdown-toggle export-button" data-toggle="dropdown" id="export-button" type="button">Export</button>
                        <div aria-labelledby="export-button" class="dropdown-menu" x-placement="top-start">
                            <!-- <a class="dropdown-item"> Export PDF</a> -->
                            <a class="dropdown-item" @click="emailContactSheet"> Export Email</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="property-items as-grid">
                <Loader v-if="loadingSession && !errorSession" />
                <Error v-if="errorSession" />
                <SessionImages :session="selectedSession" :images="selectedSessionImages" v-else />
            </div>
            <Pagination v-if="pagination.last_page >= 1 " :pagination="pagination" @paginate="getWorklistData()" :offset="5" :withWrapper="false"></Pagination>
        </div>

    </div>
</template>

<script>
import SessionRail from '@/components/reportdesk/SessionRail'
import SessionImages from '@/components/reportdesk/SessionImages'
import WorklistFilters from '@/components/reportdesk/WorklistFilters'
import Pagination from '@/components/common/Pagination'
import Loader from '@/components/common/Loader'
import Error from '@/components/common/Error'
import { debounce } from 'underscore'

export default {
  components: {
    Pagination,
    Loader,
    Error,
    SessionRail,
    SessionImages
  },
  data: function () {
    return {
      loadingSession: false,
      errorSession: false,
      pagination: {
        current_page: 1
      },
      sessions: '',
      selectedSession: '',
      selectedSessionImages: []
    }
  },
  mounted: function () {
    this.getBootParams()
  },
  methods: {
    getBootParams () {
      var self = this

      const url = '/photodesk/sessions/all'
      this.$http
        .get(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.sessions = response.data.sessions
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text:
              error.response.data || 'Error fetching contact sheet boot params',
            show: true
          })
        })
    },

    getSessionImages: function () {
      var self = this

      const url = '/photodesk/session/contactsheet'
      var data = {
        id_photodesk_session: this.selectedSession.id_photodesk_session
      }

      this.loadingSession = true
      this.errorSession = false

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.selectedSessionImages = response.data.images
          self.loadingSession = false
        })
        .catch(function (error) {
          self.loadingSession = false
          self.errorSession = true
        })
    },

    emailContactSheet: function () {
      var self = this

      const url = '/photodesk/session/contactsheet/export'
      let data = {
        id_photodesk_session: self.selectedSession.id_photodesk_session
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.emailSent = 1
          self.$store.dispatch('updateToast', {
            text: 'Email requested',
            show: true
          })
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data.error) ||
              'Something went wrong',
            show: true
          })
        })
    },

    exportContactSheet (scope) {
      console.log(scope)
      var self = this
      var search =
        this.searchString != '' ? '&search=' + this.searchString : ''
      var data =
        this.filterFormData != '' ? this.filterFormData : new FormData()
      if (scope == 'scoped') {
        var url =
          '/reportdesk/report/worklist?page=' +
          this.pagination.current_page +
          '&channel=' +
          this.selectedChannel +
          '&location=' +
          this.selectedLocation +
          search
        data.append('is_export_scoped', 1)
      } else {
        var url = '/reportdesk/report/worklist?channel=' + this.selectedChannel
        data.append('is_export', 1)
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Export Requested',
            show: true
          })
          self.$router.push('/reportdesk/reports/exported')
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('showToastAPIError')
        })
    },

    onChangeSession: function (data) {
      this.selectedSession = data
      this.getSessionImages()
    }
  }
}
</script>

<style scoped>
.rentals-list-w .rentals-list .list-controls .list-order:last-child {
  margin-left: 10px;
}
.export {
  margin-left: 10px;
}
.export-button {
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.72rem;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 0.72rem;
}
.btn-white:hover,
.btn-white:active,
.btn-white:focus,
.btn-white:visited {
  background-color: #ffffff;
  border: 1px solid #ddd;
  color: rgba(0, 0, 0, 0.4);
}
.btn-white,
.all-wrapper .fc-button {
  border: 1px solid #ddd;
}
.list-search {
  margin-left: auto;
}
.property-items {
  height: calc(100vh - 150px);
}
.rentals-list-w {
  display: flex;
  /* overflow: hidden; */
  height: calc(100vh - 54px);
  position: relative;
}

.filters-toggle {
  color: rgb(31, 97, 234) !important;
  cursor: pointer;
}

.rentals-list-w .rentals-list {
  width: 0vw !important;
}
.rentals-list-w .property-items.as-grid {
  overflow: scroll;
}
.form-control-sm {
  height: 25px;
}
</style>
